import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_orange.css";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  CustomInput,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  AutoComplete,
  Button,
  FormFeedback,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Notiflix, { Confirm, Report } from "notiflix";
import GetApiCall from "../../Api/GetApi";
import PostApiCall from "../../Api/Api";
import BreadCrumb from "../../Components/BreadCrumbComp";
import { ArrowLeft, CheckCircle, XSquare } from "react-feather";
import maleIcon from "../../assets/profile/user.jpeg";

import femaleIcon from "../../assets/profile/female-icon.png";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ImageApiUrl, PdfApiUrl } from "../../Helper/Additional";
import moment from "moment/moment";
import { delay } from "../../Helper/ToastDelay";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { flushSync } from "react-dom";
import {
  fileConverterHandler,
  imageConverterHandler,
} from "../../Helper/Converter";
import {
  addressProof,
  Allqualification,
  gender,
  idProof,
  maskDocumentNumber,
  userStatus,
} from "./helper";
import { generateCustomStyles } from "../../Helper/CustomStyleError";
import { useSelector } from "react-redux";
import CommonModal from "../../Components/CommonModal";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import RatingSummary from "../../Components/RatingSummary";

const ViewAuditor = () => {
  const history = useHistory();
  const [allCountry, setAllCountry] = useState([]);
  const [allState, setAllState] = useState([]);
  const [allCity, setAllCity] = useState([]);
  const [submitType, setSubmitType] = useState("");
  const [userData, setUserData] = useState();
  const [recruiterRemarkModal, setRecruiterRemarkModal] = useState(false);
  const [verifyModal, setVerifyModal] = useState(false);
  const [recruiterRemark, setRecruiterRemark] = useState(
    userData?.fld_onboardremark || ""
  );
  const { user } = useSelector((state) => state.profile);
  const tempUser = useSelector((state) => state.login);
  const [refresh, setRefresh] = useState(false);
  // State to hold ratings for each parameter
  const [ratingsState, setRatingsState] = useState({
    communicationSkills: 0,
    communicationRemark: "",
    relevantFieldExperience: 0,
    relevantFieldRemark: "",
    travelComfortWithinCity: 0,
    travelRemark: "",
    excelKnowledge: 0,
    excelRemark: "",
    comfortInUsingInternetAndApp: 0,
    comfortInUsingInternetRemark: "",
    availability: 0,
    availabilityRemark: "",
  });
  const { id } = useParams();

  const [recruiterStatus, setSelectedRecruiterStatus] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});

  // Define the maximum points for each category
  const maxPoints = {
    communicationSkills: 5,
    relevantFieldExperience: 5,
    travelComfortWithinCity: 5,
    excelKnowledge: 5,
    comfortInUsingInternetAndApp: 5,
    availability: 5,
  };

  const calculateOverallRating = () => {
    const totalPoints = Object.entries(ratingsState).reduce((sum, [key, value]) => {
      // Only sum numeric rating fields (skip remark fields)
      return key.toLowerCase().includes("remark") ? sum : sum + (Number(value) || 0);
    }, 0);
        const maxTotalPoints = Object.values(maxPoints).reduce(
      (sum, value) => sum + value,
      0
    );


    const normalizedRating = (totalPoints / maxTotalPoints) * 5; // Normalize to 0–5 scale
    return normalizedRating.toFixed(2); // Round to 2 decimals
  };

  useEffect(() => {
    if (id) {
      fetchUserDetail(id);
    }
  }, [id, refresh]);

  const fetchUserDetail = async (id) => {
    Notiflix.Loading.standard();
    try {
      const json = await GetApiCall.getRequest(`GetJobUserById?${id}`);

      // const json = await PostApiCall.postRequest(`GetJobUserById?${history.location.state.fld_id}`);
      const res = await json.json();

      setUserData(res?.data);
      setRefresh(false);
    } catch (error) {
      toast.error(SomethingWrong, {
        autoClose: delay,
        toastId: 1,
      });
    }
    Notiflix.Loading.remove();
  };
  const validationSchema = Yup.object().shape({
    AuditorName: Yup.string().required("Name is required"),
    // AuditorAge: Yup.string().required("Date of Birth is required"),
    PanHolderName: Yup.string().required("Name is required"),
    AuditorGmail: Yup.string()
      .email("Invalid email")
      .required("Email is required"),
    AuditorContact: Yup.string()
      .required("Contact Number is required")
      .matches(/^[6-9]\d{9}$/, "Invalid Contact"),
    AuditorAddress: Yup.string().required("Address is required"),
    AuditorCountry: Yup.object().shape({
      value: Yup.string().required("Country is required"),
    }),
    gender: Yup.object().shape({
      value: Yup.string().required("Gender is required"),
    }),

    AuditorCity: Yup.object().shape({
      value: Yup.string().required("City is required"),
    }),
    AuditorState: Yup.object().shape({
      value: Yup.string().required("State is required"),
    }),
    AuditorPincode: Yup.string()
      .required("Pincode is required")
      .matches(/^[0-9]{6}$/, "Invalid Pincode"), // Ensure 6 digits
    AuditorQual: Yup.object().shape({
      value: Yup.string().required("Qualification is required"),
    }),
    TotalExperience: Yup.string().required("Total Experience is required"),
    ExperienceTrpw: Yup.string().notRequired(),
    WorkExperience: Yup.string().notRequired(),

    // IDProof: Yup.object().shape({
    //   value: Yup.string().required("ID proof is required"),
    // }),
    // IdProofNumber: Yup.string().when("IDProof", {
    //   is: (IDProof) => IDProof?.value === "Aadhar",
    //   then: () =>
    //     Yup.string()
    //       .matches(/^\d{12}$/, "Aadhar number must be 12 digits")
    //       .required("Aadhar number is required"),
    //   otherwise: () =>
    //     Yup.string().when("IDProof", {
    //       is: (IDProof) => IDProof?.value === "Pancard",
    //       then: () =>
    //         Yup.string()
    //           .matches(
    //             /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
    //             "Pancard number is invalid"
    //           )
    //           .required("Pancard number is required"),
    //       otherwise: () =>
    //         Yup.string().when("IDProof", {
    //           is: (IDProof) => IDProof?.value === "Driving License",
    //           then: () =>
    //             Yup.string()
    //               .matches(
    //                 /^[A-Z]{2}[0-9]{13}$/,
    //                 "Driving License number is invalid"
    //               )
    //               .required("Driving License number is required"),
    //         }),
    //     }),
    // }),
    // IdProofNumber: Yup.string()
    //   .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Pancard number is invalid")
    //   .required("Pancard number is required"),
    IdProofNumber: Yup.string()
      .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN number")
      .test("fourth-letter-p", "Invalid PAN number", (value) => {
        if (!value) return false; // Validation fails if the value is empty
        return value[3] === "P"; // Check if the 4th character is 'P'
      })
      .required("PAN number is required"),

    AddressProof: Yup.object().shape({
      value: Yup.string().required("Address proof is required"),
    }),
    AddressProofNumber: Yup.string().when("AddressProof", {
      is: (AddressProof) => AddressProof?.value === "Aadhar",
      then: () =>
        Yup.string()
          .matches(/^\d{12}$/, "Aadhar number must be 12 digits")
          .required("Aadhar number is required"),
      otherwise: () =>
        Yup.string().when("AddressProof", {
          is: (AddressProof) => AddressProof?.value === "Water Bill",
          then: () =>
            Yup.string()
              .matches(/^\d{10}$/, "Water Bill number must be 10 digits")
              .required("Water Bill number is required"),
          otherwise: () =>
            Yup.string().when("AddressProof", {
              is: (AddressProof) => AddressProof?.value === "Electricity Bill",
              then: () =>
                Yup.string()
                  .matches(
                    /^[A-Z0-9]{15}$/,
                    "Electricity Bill number must be 15 alphanumeric characters"
                  )
                  .required("Electricity Bill number is required"),
              otherwise: () =>
                Yup.string().when("AddressProof", {
                  is: (AddressProof) => AddressProof?.value === "Passport",
                  then: () =>
                    Yup.string()
                      .matches(
                        /^[A-Z]{1}[0-9]{7}$/,
                        "Invalid Passport number. Must start with 1 letter followed by 7 digits."
                      )
                      .required("Passport number is required"),
                  otherwise: () =>
                    Yup.string().when("AddressProof", {
                      is: (AddressProof) => AddressProof?.value === "Voter ID",
                      then: () =>
                        Yup.string()
                          // .matches(
                          //   /^[A-Z]{3}[0-9]{7}$/,
                          //   "Invalid Voter ID. Must start with 3 letters followed by 7 digits."
                          // )
                          .required("Voter ID is required"),
                      otherwise: () =>
                        Yup.string().when("AddressProof", {
                          is: (AddressProof) =>
                            AddressProof?.value === "Driving License",
                          then: () =>
                            Yup.string()
                              // .matches(
                              //   /^[A-Z]{2}[0-9]{13}$/,
                              //   "Invalid . Must start with 2 letters followed by 13 digits."
                              // )
                              .required("Driving License number is required"),
                        }),
                    }),
                }),
            }),
        }),
    }),

    identityProofFile: Yup.string().required("Document is required"),
    qualProofFile: Yup.string().required("Document is required"),

    AddressProofFile: Yup.string().required("Document is required"),
    // resumeFile: Yup.string().required("Resume is required"),
    WorkCity: Yup.array()
      .min(1, "Preference city is required")

      .of(
        Yup.object().shape({
          label: Yup.string().required("Enter work Preference city name"),
          value: Yup.string().required("Enter work Preference city name"),
        })
      ),
    // SourceName: Yup.string().required("Source name is required"),
  });
  const profile = JSON.parse(localStorage.getItem("user"));

  const [isEditable, setIsEditable] = useState(false);

  const [imageUrl, setImageUrl] = useState("");
  const formik = useFormik({
    initialValues: {
      AuditorName: userData?.fld_name ?? "",
      AuditorAge: userData?.fld_dob ?? "",
      PhotoFile: userData?.fld_photo ?? "",
      AuditorContact: userData?.fld_mobile ?? "",
      AuditorGmail: userData?.fld_email ?? "",
      gender: userData?.fld_gender
        ? { label: userData.fld_gender, value: userData.fld_gender }
        : "",
      OnBoardStatus: userData?.fld_onboardstatus
        ? {
          label: userData.fld_onboardstatus,
          value: userData.fld_onboardstatus,
        }
        : { value: "Pending", label: "Pending" },
      AuditorAddress: userData?.fld_presentaddress ?? "",
      AuditorCity: userData?.fld_presentcity
        ? { label: userData.fld_presentcity, value: userData.fld_presentcity }
        : "",
      AuditorCountry: userData?.fld_presentcountry
        ? {
          label: userData.fld_presentcountry,
          value: userData.fld_presentcountry,
        }
        : { value: 101, label: "India" },
      AuditorState: userData?.fld_presentstate
        ? { label: userData.fld_presentstate, value: userData.fld_presentstate }
        : "",
      AuditorPincode: userData?.fld_presentpincode ?? "",
      AuditorQual: userData?.fld_qualification
        ? {
          label: userData.fld_qualification,
          value: userData.fld_qualification,
        }
        : "",
      PanHolderName: userData?.fld_identityproofname ?? "",
      TotalExperience: userData?.fld_experience ?? 0,
      ExperienceTrpw: userData?.fld_expowncompany ?? 0,
      PreEmployeeName: userData?.fld_prevcompname ?? "",
      WorkExperience: userData?.fld_worksummary ?? "",
      IDProof: userData?.fld_identityprooftype ?? "",

      bankCity: userData?.fld_bankcity ?? null,
      bankName: userData?.fld_bankname ?? null,
      bankState: userData?.fld_bankstate ?? null,
      bankHolderName: userData?.fld_holdername ?? null,
      bankIFSC: userData?.fld_ifsccode ?? null,
      bankAccountNo: userData?.fld_accountno ?? null,
      UpiNo: userData?.fld_upi ?? null,

      // ? {
      //     label: userData.fld_identityprooftype,
      //     value: userData.fld_identityprooftype,
      //   }
      // : "",
      IdProofNumber: userData?.fld_identityproofnumber ?? "",
      AddressProof: userData?.fld_addressprooftype
        ? {
          label: userData.fld_addressprooftype,
          value: userData.fld_addressprooftype,
        }
        : "",
      AddressProofNumber: userData?.fld_addressproofnumber ?? "",
      identityProofFile: userData?.fld_identityproofurl ?? null,
      identityProofFile2: "",
      AddressProofFile: userData?.fld_addressproofurl,
      qualProofFile: userData?.fld_qualificationproofurl,

      resumeFile: userData?.fld_resumeurl ?? "",
      usertype: userData?.fld_usertype
        ? { label: userData.fld_usertype, value: userData.fld_usertype }
        : { value: "Seeker", label: "Seeker" },
      SourceName: userData?.fld_sourcename ?? "",
      verifydoc: userData?.fld_verifydoc ?? "",
      verifyemp: userData?.fld_verifyemp ?? 0,
      WorkCity: userData?.work_preference
        ? userData.work_preference.split(",").map((value) => ({
          label: value,
          value: value,
        }))
        : [],
    },
    validateOnChange: true,
    validationSchema: validationSchema,
    onSubmit: async () => {
      if (submitType === "Document Verified") {
        const isValid = await formik.validateForm();
        if (Object.keys(isValid).length === 0) {
          // If no validation errors, show confirmation dialog
          Confirm.show(
            "Document Verification",
            "Are you sure you want to approve the user documents ?",
            "Yes",
            "No",
            async () => {
              // User confirmed - proceed with submission

              window.scrollTo(0, 0);
              successHandler(2); // Calls the `onSubmit` handler in `formik`
            },
            () => {
              // User canceled - optionally handle cancel action here
            },
            {}
          );
        }
      } else {
        successHandler(0);
      }
    },
  });

  useEffect(() => {
    if (userData) {
      formik.setValues({
        AuditorName: userData?.fld_name ?? "",
        AuditorAge: userData?.fld_dob ?? "",
        PhotoFile: userData?.fld_photo ?? "",
        AuditorContact: userData?.fld_mobile ?? "",
        AuditorGmail: userData?.fld_email ?? "",
        gender: userData?.fld_gender
          ? { label: userData.fld_gender, value: userData.fld_gender }
          : "",
        OnBoardStatus: userData?.fld_onboardstatus
          ? {
            label: userData.fld_onboardstatus,
            value: userData.fld_onboardstatus,
          }
          : { value: "Pending", label: "Pending" },
        AuditorAddress: userData?.fld_presentaddress ?? "",
        AuditorCity: userData?.fld_presentcity
          ? { label: userData.fld_presentcity, value: userData.fld_presentcity }
          : "",
        AuditorCountry: userData?.fld_presentcountry
          ? {
            label: userData.fld_presentcountry,
            value: userData.fld_presentcountry,
          }
          : { value: 101, label: "India" },
        AuditorState: userData?.fld_presentstate
          ? {
            label: userData.fld_presentstate,
            value: userData.fld_presentstate,
          }
          : "",
        AuditorPincode: userData?.fld_presentpincode ?? "",
        AuditorQual: userData?.fld_qualification
          ? {
            label: userData.fld_qualification,
            value: userData.fld_qualification,
          }
          : "",
        TotalExperience: userData?.fld_experience ?? 0,
        ExperienceTrpw: userData?.fld_expowncompany ?? 0,
        PreEmployeeName: userData?.fld_prevcompname ?? "",
        WorkExperience: userData?.fld_worksummary ?? "",
        IDProof: userData?.fld_identityprooftype ?? "",
        IdProofNumber: userData?.fld_identityproofnumber ?? "",
        AddressProof: userData?.fld_addressprooftype
          ? {
            label: userData.fld_addressprooftype,
            value: userData.fld_addressprooftype,
          }
          : "",
        AddressProofNumber: userData?.fld_addressproofnumber ?? "",
        identityProofFile: userData?.fld_identityproofurl ?? null,
        // bank
        bankCity: userData?.fld_bankcity ?? null,
        bankName: userData?.fld_bankname ?? null,
        bankState: userData?.fld_bankstate ?? null,
        bankHolderName: userData?.fld_holdername ?? null,
        bankIFSC: userData?.fld_ifsccode ?? null,
        bankAccountNo: userData?.fld_accountno ?? null,
        UpiNo: userData?.fld_upi ?? null,

        PanHolderName: userData?.fld_identityproofname ?? "",
        AddressProofFile: userData?.fld_addressproofurl,
        qualProofFile: userData?.fld_qualificationproofurl,
        resumeFile: userData?.fld_resumeurl ?? "",
        usertype: userData?.fld_usertype
          ? { label: userData.fld_usertype, value: userData.fld_usertype }
          : { value: "Seeker", label: "Seeker" },
        SourceName: userData?.fld_sourcename ?? "",
        verifydoc: userData?.fld_verifydoc ?? 0,
        verifyemp: userData?.fld_verifyemp ?? 0,
        WorkCity: userData?.work_preference
          ? userData.work_preference.split(",").map((value) => ({
            label: value,
            value: value,
          }))
          : [],
      });

      setRatingsState({
        communicationSkills: userData?.fld_commskill || 0,
        communicationRemark: userData?.fld_commskillremark || "",  // Assuming remark field is fld_commskillRemark
        relevantFieldExperience: userData?.fld_exp || 0,
        relevantFieldRemark: userData?.fld_expremark || "", // Assuming remark field is fld_expRemark
        travelComfortWithinCity: userData?.fld_travel || 0,
        travelRemark: userData?.fld_travelremark || "", // Assuming remark field is fld_travelRemark
        excelKnowledge: userData?.fld_knowledge || 0,
        excelRemark: userData?.fld_knowledgeremark || "", // Assuming remark field is fld_knowledgeRemark
        comfortInUsingInternetAndApp: userData?.fld_appbased || 0,
        comfortInUsingInternetRemark: userData?.fld_appbasedremark || "", // Assuming remark field is fld_appbasedRemark
        availability: userData?.fld_availability || 0,
        availabilityRemark: userData?.fld_availabilityremark || "", // Assuming remark field is fld_availabilityRemark
      });


      setSelectedRecruiterStatus(
        userData?.fld_onboardstatus
          ? {
            label: userData.fld_onboardstatus,
            value: userData.fld_onboardstatus,
          }
          : { value: "Pending", label: "Pending" }
      );

      setRecruiterRemark(userData?.fld_onboardremark);
    }
  }, [userData]); // Runs whenever `userData` changes

  const OnboardValidation = () => {
    let errors = {};

    // Validation for recruiterStatus
    if (!recruiterStatus) {
      errors.recruiterStatus = "Status is required.";
    }

    // Validation for recruiterRemark
    if (!recruiterRemark || recruiterRemark == null) {
      errors.recruiterRemark = "Remarks are required.";
    } else if (recruiterRemark.trim().length > 150) {
      errors.recruiterRemark = "Remarks must not exceed 150 characters.";
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return false; // Return false if validation fails
    }

    // Clear errors if validation passes
    setValidationErrors({});
    return true; // Return true if validation passes
  };

  const handleOnBoardStatus = async () => {

    // console.log("ratingsState", ratingsState)
    // return
    // Perform validation first
    const isValid = OnboardValidation();
    if (isValid) {
      // Proceed with the API call if validation passes
      // Notiflix.Loading.standard();
      setRecruiterRemarkModal(false);
      try {
        let rating = calculateOverallRating();
    
        const result = await PostApiCall.postRequest(
          {
            id: userData?.fld_id[0],
            onboardstatus: recruiterStatus.value,
            onboardpreviousstatus: userData.fld_onboardstatus,
            onboardremark: recruiterRemark || "",
            email: userData?.fld_email || "",
            name: userData?.fld_name || "",
            userid: userData?.fld_id[0],
            overall: Number(rating),
            commskill: ratingsState?.communicationSkills,
            exp: ratingsState?.excelKnowledge,
            travel: ratingsState.travelComfortWithinCity,
            knowledge: ratingsState.excelKnowledge,
            appbased: ratingsState?.comfortInUsingInternetAndApp,
            availability: ratingsState?.availability,
            ratingid: userData?.fld_ratingid || 0,
            // Remark
            commskillremremark: ratingsState.communicationRemark || '',
            expremremark: ratingsState.excelRemark || "",
            travelremremark: ratingsState.travelRemark || "",
            knowledgeremremark: ratingsState.excelRemark || "",
            appbasedremremark: ratingsState.comfortInUsingInternetRemark || "",
            availabilityremark: ratingsState.availabilityRemark || ""


          },
          "JobOnboardUser"
        );

        const response = await result.json();
        if (result.status == 200) {
          Notiflix.Loading.remove();
          toast.success(response?.data, { autoClose: delay, toastId: 1 });
          history.goBack();
        } else {
          Notiflix.Loading.remove();
          toast.error(response?.data, { autoClose: delay, toastId: 1 });
        }
      } catch (error) {
        Notiflix.Loading.remove();
        console.error("API call failed:", error);
        toast.error(SomethingWrong, { autoClose: delay, toastId: 1 });
        // Optionally, show an error message to the user
      }
    }
  };

  const successHandler = async (docVerified) => {
    try {
      Notiflix.Loading.standard();

      const UserUpdate = {
        id: userData?.fld_id[0],
        name: formik.values.AuditorName,
        mobile: formik.values.AuditorContact,
        email: formik.values.AuditorGmail,
        usertype: formik.values.usertype.value,
        updatedon: moment().format("ll"),
        profileflag: 1,
        onboardstatus: formik.values.OnBoardStatus.value || "Pending",
      };

      const payload = {
        name: formik.values.AuditorName,
        mobile: formik.values.AuditorContact,
        email: formik.values.AuditorGmail,
        usertype: formik.values.usertype.value,
        updatedon: moment().format("ll"),
        id: userData?.fld_id[1],
        photo: formik.values.PhotoFile,
        employeeid: userData.fld_employeeid,
        dob: formik.values.AuditorAge,
        gender: formik.values.gender.value,
        presentaddress: formik.values.AuditorAddress,
        presentcountry: formik.values.AuditorCountry.label,
        presentstate: formik.values.AuditorState.label,
        presentcity: formik.values.AuditorCity.label,
        presentpincode: formik.values.AuditorPincode,
        permanentaddress: "456 Park St",
        permanentcountry: "Country2",
        permanentstate: "State2",
        permanentcity: "City2",
        permanentpincode: "67890",
        qualification: formik.values.AuditorQual.value,
        experience: formik.values.TotalExperience || 0,
        expowncompany: formik.values.ExperienceTrpw || 0,
        prevcompname: formik.values.PreEmployeeName || "",
        worksummary: formik.values.WorkExperience,
        identityprooftype: "Pancard",
        identityproofnumber: formik.values.IdProofNumber,
        identityproofname: formik.values.PanHolderName || "",
        addressprooftype: formik.values.AddressProof.value,
        addressproofnumber: formik.values.AddressProofNumber,
        identityproofurl: userData.fld_identityproofurl,
        qualificationproofurl: userData.fld_qualificationproofurl,
        addressproofurl: userData.fld_addressproofurl,
        sourcename: formik.values.SourceName,
        resumeurl: userData.fld_resumeurl,
        verifyaccount: 1,
        userid: userData?.fld_id[0],
        verifyemp:
          formik.values.verifyemp?.value || formik.values.verifyemp || 0,
      };

      let cityArr = await formik.values.WorkCity.map((ele) =>
        ele.value.trim()
      ).join(",");
      payload.workcity = cityArr;

      // return

      const registerCandidateResult = await PostApiCall.postRequest(
        UserUpdate,
        "UpdateJobUsers"
      );

      if (registerCandidateResult.status === 200) {
        const promises = [];

        // Wait for all file conversions to complete
        if (
          formik.values.identityProofFile &&
          typeof formik.values.identityProofFile === "object"
        ) {
          promises.identityProofPromise = fileConverterHandler(
            formik.values.identityProofFile,
            userData.fld_id[0],
            "Identity"
          );
        }
        if (
          formik.values.qualProofFile &&
          typeof formik.values.qualProofFile === "object"
        ) {
          promises.qualProofPromise = fileConverterHandler(
            formik.values.qualProofFile,
            userData.fld_id[0],
            "Qualification"
          );
        }

        if (
          formik.values.AddressProofFile &&
          typeof formik.values.AddressProofFile === "object"
        ) {
          promises.addressProofPromise = fileConverterHandler(
            formik.values.AddressProofFile,
            userData.fld_id[0],
            "Address"
          );
        }

        if (
          formik.values.resumeFile &&
          typeof formik.values.resumeFile === "object"
        ) {
          promises.resumePromise = fileConverterHandler(
            formik.values.resumeFile,
            userData.fld_id[0],
            "Resume"
          );
        }

        if (
          formik.values.PhotoFile &&
          typeof formik.values.PhotoFile === "object"
        ) {
          promises.photoPromise = imageConverterHandler(
            formik.values.PhotoFile,
            userData.fld_id[0],
            "Profile"
          );
        }

        const results = await Promise.allSettled(Object.values(promises));

        let doc =
          userData.fld_verifydoc === 0
            ? results.filter(
              (ele) =>
                ele.status === "fulfilled" &&
                !ele.value.includes("Job/Resume/") &&
                !ele.value.includes("Job/Profile")
            ).length === 3 ? 1 : 0
            : docVerified;



        // Assign results to the corresponding payload keys
        Object.keys(promises).forEach((promiseKey, index) => {
          const result = results[index];
          if (result.status === "fulfilled") {
            switch (promiseKey) {
              case "identityProofPromise":
                payload.identityproofurl = result.value;
                break;
              case "addressProofPromise":
                payload.addressproofurl = result.value;
                break;
              case "qualProofPromise":
                payload.qualificationproofurl = result.value;
                break;
              case "resumePromise":
                payload.resumeurl = result.value;
                break;
              case "photoPromise":
                payload.photo = result.value;
                break;
              default:
                break;
            }
          }
        });

        let addJobAuditorResult;
        payload.verifydoc = docVerified === 2 ? docVerified : doc
        if (userData.fld_id[1] !== null) {
          addJobAuditorResult = await PostApiCall.postRequest(
            payload,
            "UpdateJobAuditor"
          );
        } else {
          addJobAuditorResult = await PostApiCall.postRequest(
            payload,
            "AddJobAuditor"
          );
        }

        if (
          addJobAuditorResult.status === 200 ||
          addJobAuditorResult.status === 201
        ) {
          // Success
          setRefresh(true);
          Notiflix.Loading.remove();

          // toast.success("Auditor updated Successfully", {
          //   autoClose: delay,
          // });
          Report.success(
            `Updated Succesfully`,
            // '"Do not try to become a person of success but try to become a person of value." <br/><br/>- Albert Einstein',
            "",
            "Okay"
          );
          // history.push("/auditor-list");
          history.goBack();
        } else {
          // Handle AddJobAuditor API call error
          const errorMessage = await addJobAuditorResult.json();
          Notiflix.Loading.remove();
          toast.error(errorMessage.data, { autoClose: delay, toastId: 1 });
        }
      } else {
        // Handle RegisterCandidate API call error
        const errorMessage = await registerCandidateResult.json();
        Notiflix.Loading.remove();
        toast.error(errorMessage.data, { autoClose: delay, toastId: 1 });
      }
    } catch (error) {
      // Handle general error

      toast.error(SomethingWrong, { autoClose: delay, toastId: 1 });
      Notiflix.Loading.remove();
    }
  };
  const submitHandler = async (type) => {
    setIsEditable(true);
    setSubmitType(type);
    window.scrollTo(0, 0);
    formik.handleSubmit();
  };

  const handleRemoveImage = () => {
    setImageUrl("");
  };

  const VerifyEmployeeHandler = () => {
    setSubmitType("Employee Verify");
    successHandler(2); // Calls the `onSubmit` handler in `formik`
    setVerifyModal(false);
  };

  useEffect(() => {
    const getCountry = () => {
      GetApiCall.getRequest("GetCountry").then((resultdes) =>
        resultdes.json().then((obj) => {
          setAllCountry(obj?.data);
          // Notiflix.Loading.remove()
        })
      );
    };

    getCountry();
  }, [formik.values?.AuditorCountry?.value]);

  useEffect(() => {
    const getState = () => {
      const filterState = allCountry?.find(
        (i) => i.label == formik.values?.AuditorCountry?.label
      );
      PostApiCall.postRequest(
        { countryid: filterState?.value },
        "GetState"
      ).then((resultdes) =>
        resultdes.json().then((obj) => {
          setAllState(obj?.data);
          // formik.setFieldValue("AuditorState", obj?.data[0]);
          const currentState = obj?.data?.find(
            (state) => state?.label === formik.values?.AuditorState?.label
          );
          // formik.setFieldValue("AuditorState", currentState);
          // Notiflix.Loading.remove()
        })
      );
    };
    getState();
  }, [formik.values.AuditorCountry, allCountry]);
  useEffect(() => {
    const getCity = () => {
      const filterCity = allState?.find(
        (i) => i?.label == formik.values?.AuditorState?.label
      );
      PostApiCall.postRequest({ stateid: filterCity?.value }, "GetCity").then(
        (resultdes) =>
          resultdes.json().then((obj) => {
            const cities = obj?.data || [];
            setAllCity(cities);
            if (cities.length < 0) {
              formik.setFieldValue("AuditorCity", {
                value: "none",
                label: "None",
              });
            }
            // Notiflix.Loading.remove()
          })
      );
    };
    getCity();
  }, [formik.values.AuditorState, allState]);
  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() - 17);

  // Array of rating fields
  const ratingFields = [
    { heading: "Communication Skills", id: "communicationSkills", name: "communicationRemark" },
    { heading: "Relevant Field Experience", id: "relevantFieldExperience", name: "relevantFieldRemark" },
    { heading: "Travel Comfort within City", id: "travelComfortWithinCity", name: "travelRemark" },
    { heading: "Excel Knowledge", id: "excelKnowledge", name: "excelRemark" },
    {
      heading: "Comfort in Using Internet & App-based Audits",
      id: "comfortInUsingInternetAndApp",
      name: "comfortInUsingInternetRemark"
    },
    { heading: "Availability", id: "availability", name: "availabilityRemark" },
  ];



  return (
    <div className="App mt-5 ">
      <section id="" className="section  px-md-5">
        <div className="container">
          <BreadCrumb icon={false} subitem={"View Auditor"} />

          <div className="auditorApp mx-3">
            <div className="row">
              <FormGroup className="" style={{ marginTop: "0px" }}>
                {/* <h2>Auditor Form</h2> */}
                <Card
                  className="my-3 border-0"
                  style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
                >
                  <CardBody>
                    <button
                      type="reset"
                      className="cancelBtn ml-2  mb-md-0 mb-2"
                      style={{ marginRight: "10px" }}
                      onClick={() => {
                        setIsEditable(false);
                        // history.push("/auditor-list");
                        history.goBack();
                      }}
                    >
                      <ArrowLeft />
                    </button>
                    {!isEditable && (
                      <Button
                        // className="btns"
                        className="basebgColor text-light px-3 py-1 rounded-3 ml-2 mb-md-0 mb-2"
                        style={{ textTransform: "capitalize" }}
                        onClick={() => setIsEditable(true)}
                      >
                        Edit Details
                      </Button>
                    )}

                    {(profile?.fld_isadmin === 1 ||
                      profile?.fld_usertype === "Staff") && (
                        <>
                          {(userData?.fld_verifydoc !== 2 ||
                            userData?.fld_verifydoc == null) && (
                              <button
                                className="btnsborder ml-2  mb-md-0 mb-2"
                                style={{
                                  marginRight: "10px",
                                  textTransform: "capitalize",
                                }}
                                onClick={() => {
                                  submitHandler("Document Verified");
                                }}
                              >
                                Document Status
                              </button>
                            )}
                        </>
                      )}
                    {(profile?.fld_isadmin === 1 ||
                      profile?.fld_usertype === "Staff") && (
                        <>
                          <Button
                            className="btnsborder ml-2  mb-md-0 mb-2"
                            style={{
                              marginRight: "10px",
                              textTransform: "capitalize",
                            }}
                            onClick={() => {
                              setRecruiterRemarkModal(true);
                            }}
                          >
                            Onboarding Status
                          </Button>
                        </>
                      )}
                    {(profile?.fld_isadmin === 1 ||
                      profile?.fld_usertype === "Staff") && (
                        <>
                          {((userData?.fld_verifyemp == 0 ||
                            userData?.fld_verifyemp == null) && userData?.fld_profileflag == 1) && (
                              <button
                                className="btnsborder ml-2  mb-md-0 mb-2"
                                style={{
                                  marginRight: "10px",
                                  textTransform: "capitalize",
                                }}
                                onClick={() => {
                                  setVerifyModal(true);
                                }}
                              >
                                Verify Employee
                              </button>
                            )}
                        </>
                      )}
                  </CardBody>
                </Card>
                <Card
                  id="jobCard "
                  className="border-0 position-relative"
                  style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
                >
                  {(userData?.fld_verifyemp && userData?.fld_verifyemp !== 0) ? (
                    <div
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        background: "#28a745",
                        color: "white",
                        padding: "5px 10px",
                        borderRadius: "20px",
                        fontSize: "14px",
                      }}
                    >
                      <CheckCircle size={16} color="white" />
                      Verified
                    </div>
                  ) : ""}
                  <h6 className="my-3 ml-4 headingStyle">Basic Information</h6>
                  <CardBody>
                    <div>
                      <Row>
                        <Col sm={"12"}>
                          <div className="d-flex flex-wrap align-items-center">
                            <div className="avatar avatar-xl mb-4">
                              <img
                                src={
                                  imageUrl
                                    ? imageUrl
                                    : process.env.REACT_APP_FILE_PATH_URL +
                                    userData?.fld_photo
                                }
                                alt="User Image"
                                width={"100%"}
                                height={"100%"}
                                className="shadow"
                                onError={(e) => (e.target.src = maleIcon)}
                              />
                            </div>
                            {isEditable && (
                              <div className="ml-md-3 mb-4">
                                <p className="ml-2">
                                  (Only *.jpeg and *.png images will be
                                  accepted)
                                </p>

                                <label
                                  htmlFor="imgUpload"
                                  color="primary"
                                  outline={true}
                                  className="btn-border ml-2 mt-3 px-2 "
                                >
                                  Upload Profile Image
                                </label>
                                <input
                                  invalid={
                                    formik.touched.AuditorName &&
                                    !!formik.errors.AuditorName
                                  }
                                  style={{ display: "none" }}
                                  type="file"
                                  accept="image/*"
                                  id="imgUpload"
                                  capture
                                  onChange={(e) => {
                                    e.preventDefault();
                                    const file = e.target.files[0];
                                    setImageUrl(URL.createObjectURL(file));

                                    formik.setFieldValue("PhotoFile", file);
                                    if (file && file.size > 5000000) {
                                      Notiflix.Notify.failure(
                                        "File too large, upload file less than 5 Mb."
                                      );
                                    }
                                  }}
                                />

                                {imageUrl && (
                                  <XSquare
                                    size={30}
                                    className="text-danger"
                                    onClick={handleRemoveImage}
                                  />
                                )}
                              </div>
                            )}
                          </div>
                        </Col>
                        <Col sm="6">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              Full Name<span className="mandatory">*</span>
                            </Label>
                            <Input
                              invalid={
                                formik.touched.AuditorName &&
                                !!formik.errors.AuditorName
                              }
                              disabled={!isEditable}
                              type="text"
                              name="AuditorName"
                              id="nameVertical"
                              style={{ textTransform: "capitalize" }}
                              placeholder="Enter your name"
                              onChange={formik.handleChange}
                              value={formik.values.AuditorName}
                            />
                            {formik.touched.AuditorName &&
                              formik.errors.AuditorName && (
                                <FormFeedback>
                                  {formik.errors.AuditorName}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                        <Col sm="6">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              Email Address<span className="mandatory">*</span>
                            </Label>
                            <Input
                              invalid={
                                formik.touched.AuditorGmail &&
                                !!formik.errors.AuditorGmail
                              }
                              disabled
                              type="text"
                              name="AuditorGmail"
                              id="nameVertical"
                              placeholder="Enter your email"
                              onChange={formik.handleChange}
                              value={formik.values.AuditorGmail}
                            />
                            {formik.touched.AuditorGmail &&
                              formik.errors.AuditorGmail && (
                                <FormFeedback>
                                  {formik.errors.AuditorGmail}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                        <Col sm="6">
                          <FormGroup>
                            <Label htmlFor="">
                              Contact Number<span className="mandatory">*</span>
                            </Label>

                            <Input
                              invalid={
                                formik.touched.AuditorContact &&
                                !!formik.errors.AuditorContact
                              }
                              type="text"
                              disabled={!isEditable}
                              name="AuditorContact"
                              id="nameVertical"
                              placeholder="Enter your Contact"
                              onChange={formik.handleChange}
                              value={formik.values.AuditorContact}
                            />
                            {formik.touched.AuditorContact &&
                              formik.errors.AuditorContact && (
                                <FormFeedback>
                                  {formik.errors.AuditorContact}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label htmlFor="">
                              Gender<span className="mandatory">*</span>
                            </Label>
                            <Select
                              isDisabled={!isEditable}
                              className={`React ${formik.touched.gender && formik.errors.gender
                                ? "is-invalid"
                                : ""
                                }`}
                              classNamePrefix="Select"
                              name="gender"
                              onChange={(selectedOption) => {
                                formik.setFieldValue("gender", selectedOption);
                              }}
                              options={gender}
                              value={formik.values.gender}
                              styles={generateCustomStyles("gender", formik)}
                            />
                            {formik.touched.gender && formik.errors.gender && (
                              <FormFeedback>
                                {formik.errors.gender.value}
                              </FormFeedback>
                            )}
                          </FormGroup>
                        </Col>

                        <Col sm="6">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              Date of Birth <span className="mandatory">*</span>
                            </Label>
                            <Flatpickr
                              disabled={!isEditable}
                              className={`form-control ${isEditable ? "" : "disabled-input"
                                }`}
                              // value={activeUpto}
                              placeholder="DD-MM-YYYY"
                              options={{
                                altInput: true,
                                altFormat: "F j, Y",
                                dateFormat: "Y-m-d",
                                maxDate: maxDate,
                              }}
                              name="AuditorAge"
                              value={formik.values.AuditorAge}
                              // onChange={(dates) => {
                              //   // setAuditorAge(dates[0].toISOString().split('T')[0]);
                              //   formik.setFieldValue(
                              //     "AuditorAge",
                              //     dates[0].toISOString().split("T")[0]
                              //   ); // Update formik value
                              // }}
                              onChange={(dates) => {
                                if (dates?.[0]) {
                                  const formattedDate = moment(dates[0]).format(
                                    "YYYY-MM-DD"
                                  );
                                  formik.setFieldValue(
                                    "AuditorAge",
                                    formattedDate
                                  );
                                } else {
                                  formik.setFieldValue("AuditorAge", ""); // Handle case when date is cleared
                                }
                              }}
                            />

                            {formik.touched.AuditorAge &&
                              formik.errors.AuditorAge && (
                                <FormFeedback>
                                  {formik.errors.AuditorAge}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                        {/* {
                         (profile?.fld_isadmin === 1 && profile?.fld_usertype==="Staff") && 
                      <Col sm="6">
                        <FormGroup>
                          <Label htmlFor="">
                            User Type<span className="mandatory">*</span>
                          </Label>
                          <Select
                            isDisabled={!isEditable}
                            className={`React ${
                              formik.touched.usertype && formik.errors.usertype
                                ? "is-invalid"
                                : ""
                            }`}
                            placeholder="Select"
                            classNamePrefix="select"
                            name="usertype"
                            onChange={(selectedOption) => {
                              formik.setFieldValue("usertype", selectedOption);
                            }}
                            options={[
                              { value: "Auditor", label: "Auditor" },
                              { value: "Seeker", label: "Seeker" },
                            ]}
                            value={formik.values.usertype}
                            styles={generateCustomStyles("usertype", formik)}
                          />
                          {formik.touched.usertype &&
                            formik.errors.usertype && (
                              <FormFeedback>
                                {formik.errors.usertype.value}
                              </FormFeedback>
                            )}
                        </FormGroup>
                      </Col>
                      } */}

                        <Col sm="6">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              Preference Cities{" "}
                              <span className="mandatory">*</span>
                            </Label>
                            <CreatableSelect
                              isClearable
                              className={`React ${formik.touched.WorkCity &&
                                formik.errors.WorkCity
                                ? "is-invalid"
                                : ""
                                }`}
                              isDisabled={!isEditable}
                              classNamePrefix="select"
                              name="color"
                              isMulti
                              // placeholder="Select.."
                              noOptionsMessage={() =>
                                "Type to create new city name"
                              }
                              onChange={(selectedOption) =>
                                formik.setFieldValue("WorkCity", selectedOption)
                              }
                              value={formik.values.WorkCity}
                              styles={generateCustomStyles("WorkCity", formik)}
                            />
                            {formik.touched.WorkCity &&
                              formik.errors.WorkCity && (
                                <FormFeedback>
                                  {formik.errors.WorkCity}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                        <Col sm="6">
                          <FormGroup>
                            <Label htmlFor="">
                              Where Did You Hear About Us?
                            </Label>

                            <Input
                              invalid={
                                formik.touched.SourceName &&
                                !!formik.errors.SourceName
                              }
                              type="text"
                              name="SourceName"
                              id="nameVertical"
                              placeholder="Enter source name"
                              onChange={formik.handleChange}
                              value={formik.values.SourceName}
                              disabled={!isEditable}
                            />
                            {formik.touched.SourceName &&
                              formik.errors.SourceName && (
                                <FormFeedback>
                                  {formik.errors.SourceName}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                  </CardBody>
                </Card>
                <Card
                  className="mt-3 border-0"
                  id="jobCard"
                  style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
                >
                  <h6 className="my-3 ml-4 headingStyle">Present Address</h6>
                  <CardBody>
                    <div>
                      <Row>
                        <Col sm="12">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              Address
                              <span className="mandatory">*</span>
                            </Label>
                            <Input
                              invalid={
                                formik.touched.AuditorAddress &&
                                !!formik.errors.AuditorAddress
                              }
                              disabled={!isEditable}
                              type="textarea"
                              className="p-3"
                              name="AuditorAddress"
                              // id="nameVertical"
                              onChange={formik.handleChange}
                              value={formik.values.AuditorAddress}
                              maxLength={400}
                            />
                            {/* <div
                              className="text-end text-muted mt-1"
                              style={{ fontSize: "12px" }}
                            >
                              {formik.values.AuditorAddress?.length}/400
                            </div> */}
                            {formik.touched.AuditorAddress &&
                              formik.errors.AuditorAddress && (
                                <FormFeedback>
                                  {formik.errors.AuditorAddress}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>

                        <Col sm="6" style={{ zIndex: "5" }}>
                          <FormGroup>
                            <Label htmlFor="">
                              Country<span className="mandatory">*</span>
                            </Label>
                            <Select
                              isDisabled={!isEditable}
                              className={`React ${formik.touched.AuditorCountry &&
                                formik.errors.AuditorCountry
                                ? "is-invalid"
                                : ""
                                }`}
                              classNamePrefix="select"
                              name="AuditorCountry"
                              onChange={(selectedOption) => {
                                formik.setFieldValue(
                                  "AuditorCountry",
                                  selectedOption
                                );
                                // formik.setFieldValue(
                                //   "AuditorState",
                                //   allState[0]
                                // );
                                formik.setFieldValue("AuditorState", "");
                                formik.setFieldValue("AuditorCity", "");
                              }}
                              options={allCountry}
                              value={formik.values.AuditorCountry}
                              styles={generateCustomStyles(
                                "AuditorCountry",
                                formik
                              )}
                            />
                            {formik.touched.AuditorCountry &&
                              formik.errors.AuditorCountry && (
                                <FormFeedback>
                                  {formik.errors.AuditorCountry.value}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                        <Col sm="6" style={{ zIndex: "4" }}>
                          <FormGroup>
                            <Label htmlFor="">
                              State<span className="mandatory">*</span>
                            </Label>
                            <Select
                              isDisabled={!isEditable}
                              className={`React ${formik.touched.AuditorState &&
                                formik.errors.AuditorState
                                ? "is-invalid"
                                : ""
                                }`}
                              classNamePrefix="select"
                              name="AuditorState"
                              onChange={(selectedOption) => {
                                formik.setFieldValue(
                                  "AuditorState",
                                  selectedOption
                                );
                                formik.setFieldValue("AuditorCity", "");
                              }}
                              value={formik.values.AuditorState}
                              options={allState}
                              styles={generateCustomStyles(
                                "AuditorState",
                                formik
                              )}
                            />
                            {formik.touched.AuditorState &&
                              formik.errors.AuditorState && (
                                <FormFeedback>
                                  {formik.errors.AuditorState.value}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>

                        <Col sm="6" style={{ zIndex: "3" }}>
                          <FormGroup>
                            <Label htmlFor="">
                              City<span className="mandatory">*</span>
                            </Label>
                            <Select
                              isDisabled={!isEditable}
                              className={`React ${formik.touched.AuditorCity &&
                                formik.errors.AuditorCity
                                ? "is-invalid"
                                : ""
                                }`}
                              classNamePrefix="select"
                              name="AuditorCity"
                              onChange={(selectedOption) =>
                                formik.setFieldValue(
                                  "AuditorCity",
                                  selectedOption
                                )
                              }
                              options={allCity}
                              value={formik.values.AuditorCity}
                              styles={generateCustomStyles(
                                "AuditorCity",
                                formik
                              )}
                            />
                            {formik.touched.AuditorCity &&
                              formik.errors.AuditorCity && (
                                <FormFeedback>
                                  {formik.errors.AuditorCity.value}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>

                        <Col sm="6">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              Pincode<span className="mandatory">*</span>
                            </Label>
                            <Input
                              invalid={
                                formik.touched.AuditorPincode &&
                                !!formik.errors.AuditorPincode
                              }
                              disabled={!isEditable}
                              type="text"
                              name="AuditorPincode"
                              id="nameVertical"
                              placeholder="Enter your Pincode"
                              onChange={formik.handleChange}
                              value={formik.values.AuditorPincode}
                            // invalid={formik.errors.AuditorPincode ? true : false}
                            />
                            {formik.touched.AuditorPincode &&
                              formik.errors.AuditorPincode && (
                                <FormFeedback>
                                  {formik.errors.AuditorPincode}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                  </CardBody>
                </Card>
                <Card
                  className="mt-3 border-0"
                  id="jobCard"
                  style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
                >
                  <h6 className="my-3 ml-4 headingStyle">
                    Qualification & Experience
                  </h6>
                  <CardBody>
                    <div>
                      <Row>
                        <Col sm="6" style={{ zIndex: "2" }}>
                          <FormGroup>
                            <Label htmlFor="">
                              Qualification<span className="mandatory">*</span>
                            </Label>
                            <Select
                              isDisabled={!isEditable}
                              className={`React ${formik.touched.AuditorQual &&
                                formik.errors.AuditorQual
                                ? "is-invalid"
                                : ""
                                }`}
                              classNamePrefix="select"
                              name="AuditorQual"
                              onChange={(selectedOption) =>
                                formik.setFieldValue(
                                  "AuditorQual",
                                  selectedOption
                                )
                              }
                              value={formik.values.AuditorQual}
                              options={Allqualification}
                              styles={generateCustomStyles(
                                "AuditorQual",
                                formik
                              )}
                            />
                            {formik.touched.AuditorQual &&
                              formik.errors.AuditorQual && (
                                <FormFeedback>
                                  {formik.errors.AuditorQual.value}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                        <Col sm="6">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              Qualification Certificate{" "}
                              {formik?.values?.qualProofFile ? (
                                <a
                                  href={
                                    formik.values.qualProofFile instanceof File
                                      ? URL.createObjectURL(
                                        formik.values?.qualProofFile
                                      ) // Show newly uploaded file
                                      : process.env.REACT_APP_FILE_PATH_URL +
                                      formik.values?.qualProofFile // Show existing file URL
                                  }
                                  target="__blank"
                                  className="ml-2 text-primary"
                                >
                                  ( View )
                                </a>
                              ) : (
                                "(upload .pdf file)"
                              )}
                              <span className="mandatory cursor-pointer">
                                *
                              </span>
                            </Label>

                            <CustomInput
                              type="file"
                              name="qualProofFile"
                              accept="application/pdf"
                              id="nameVertical"
                              disabled={!isEditable}
                              invalid={
                                formik.touched.qualProofFile &&
                                !!formik.errors.qualProofFile
                              }
                              onChange={(e) => {
                                e.preventDefault();
                                const file = e.target.files[0];
                                formik.setFieldValue("qualProofFile", file);
                                if (file && file.size > 5000000) {
                                  Notiflix.Notify.failure(
                                    "File too large, upload file less than 5 Mb."
                                  );
                                }
                              }}
                            />

                            {formik.touched.qualProofFile &&
                              formik.errors.qualProofFile && (
                                <div
                                  style={{
                                    width: "100%",
                                    marginTop: "3px",
                                    fontSize: "80%",
                                    color: "#dc3545",
                                  }}
                                >
                                  {formik.errors.qualProofFile}
                                </div>
                              )}
                          </FormGroup>
                        </Col>
                        <Col sm="4">
                          <FormGroup>
                            <Label htmlFor="">
                              Experience<span className="mandatory">*</span>
                            </Label>
                            <Input
                              invalid={
                                formik.touched.TotalExperience &&
                                !!formik.errors.TotalExperience
                              }
                              disabled={!isEditable}
                              type="number"
                              min={0}
                              name="TotalExperience"
                              id="nameVertical"
                              placeholder="Enter your Total Experience"
                              onChange={formik.handleChange}
                              value={formik.values.TotalExperience}
                            />
                            {formik.touched.TotalExperience &&
                              formik.errors.TotalExperience && (
                                <FormFeedback>
                                  {formik.errors.TotalExperience}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>

                        <Col sm="3">
                          <div className="text-center">
                            <Label htmlFor="nameVertical">
                              Experience with TRPW ?
                            </Label>
                            <div className="d-flex justify-content-center my-2">
                              <div className="mr-5">
                                <Input
                                  type="radio"
                                  name="ExperienceTrpw"
                                  onChange={() =>
                                    formik.setFieldValue("ExperienceTrpw", 1)
                                  }
                                  style={{ accentColor: "#c16d18" }}
                                  checked={formik.values.ExperienceTrpw == 1}
                                  value={formik.values.ExperienceTrpw}
                                />
                                <span>Yes</span>
                              </div>
                              <div className="d-flex ">
                                {" "}
                                <Input
                                  type="radio"
                                  name="ExperienceTrpw"
                                  onChange={() =>
                                    formik.setFieldValue("ExperienceTrpw", 0)
                                  }
                                  style={{ accentColor: "#c16d18" }}
                                  checked={formik.values.ExperienceTrpw == 0}
                                  value={formik.values.ExperienceTrpw}
                                />
                                <span>No</span>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col sm="5">
                          <FormGroup>
                            <Label htmlFor="">
                              Name of the Manager / Employee ID
                            </Label>
                            <Input
                              type="text"
                              name="PreEmployeeName"
                              id="nameVertical"
                              placeholder="Name / Employee ID"
                              onChange={formik.handleChange}
                              value={formik.values.PreEmployeeName}
                              disabled={formik.values.ExperienceTrpw == 0}
                            />
                          </FormGroup>
                        </Col>

                        <Col sm="12">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              Work Experiences
                              <span className="mandatory"></span>
                            </Label>
                            <Input
                              disabled={!isEditable}
                              type="textarea"
                              name="WorkExperience"
                              id="nameVertical"
                              style={{ height: "10em" }}
                              className="pt-2"
                              placeholder="Brief your previous Work Experiences"
                              onChange={formik.handleChange}
                              value={formik.values.WorkExperience}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                  </CardBody>
                </Card>
                <Card
                  className="mt-3 border-0"
                  id="jobCard"
                  style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
                >
                  <h6 className="my-3 ml-4 headingStyle">Verification</h6>
                  <CardBody>
                    <div>
                      <Row>
                        <Col sm="4">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              PAN Number
                              <span className="mandatory">*</span>
                            </Label>
                            <Input
                              invalid={
                                formik.touched.IdProofNumber &&
                                !!formik.errors.IdProofNumber
                              }
                              disabled={!isEditable}
                              type="text"
                              name="IdProofNumber"
                              id="nameVertical"
                              placeholder="ID Number"
                              // onChange={formik.handleChange}
                              onChange={(e) => {
                                const uppercaseValue = e.target.value.toUpperCase();
                                formik.setFieldValue("IdProofNumber", uppercaseValue);
                              }}
                              value={
                                isEditable
                                  ? formik.values.IdProofNumber?.toUpperCase()
                                  : maskDocumentNumber(
                                    formik.values.IdProofNumber
                                  )
                              }
                            />
                            {formik.touched.IdProofNumber &&
                              formik.errors.IdProofNumber && (
                                <FormFeedback>
                                  {formik.errors.IdProofNumber}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                        <Col sm="4">
                          <FormGroup>
                            <Label htmlFor="">
                              Name as per PAN{" "}
                              <span className="mandatory cursor-pointer">
                                *
                              </span>
                            </Label>

                            <Input
                              type="text"
                              name="PanHolderName"
                              id="nameVertical"
                              placeholder="Enter your Name"
                              style={{ textTransform: "capitalize" }}
                              onChange={formik.handleChange}
                              disabled={!isEditable}
                              value={formik.values.PanHolderName}
                              invalid={
                                formik.touched.PanHolderName &&
                                !!formik.errors.PanHolderName
                              }
                            />
                            {formik.touched.PanHolderName &&
                              formik.errors.PanHolderName && (
                                <FormFeedback>
                                  {formik.errors.PanHolderName}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                        <Col sm="4">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              PAN Proof
                              {formik?.values?.identityProofFile ? (
                                <a
                                  href={
                                    userData.fld_identityproofurl === ""
                                      ? URL.createObjectURL(
                                        formik.values?.identityProofFile
                                      )
                                      : process.env.REACT_APP_FILE_PATH_URL +
                                      userData.fld_identityproofurl
                                  }
                                  target="__blank"
                                  className="ml-2 text-primary"
                                >
                                  ( View )
                                </a>
                              ) : (
                                ""
                              )}
                              <span className="mandatory cursor-pointer">
                                *
                              </span>
                            </Label>

                            <CustomInput
                              type="file"
                              name="identityProofFile"
                              accept="application/pdf"
                              id="nameVertical"
                              disabled={!isEditable}
                              invalid={
                                formik.touched.identityProofFile &&
                                !!formik.errors.identityProofFile
                              }
                              onChange={(e) => {
                                e.preventDefault();
                                const file = e.target.files[0];

                                formik.setFieldValue("identityProofFile", file);

                                if (file && file.size > 5000000) {
                                  Notiflix.Notify.failure(
                                    "File too large, upload file less than 5 Mb."
                                  );
                                }
                              }}
                            />

                            {formik.touched.identityProofFile &&
                              formik.errors.identityProofFile && (
                                <FormFeedback>
                                  {formik.errors.identityProofFile}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>

                        <Col sm="4" style={{ zIndex: "2" }}>
                          <FormGroup>
                            <Label htmlFor="">
                              {" "}
                              Address Proof<span className="mandatory">*</span>
                            </Label>
                            <Select
                              isDisabled={!isEditable}
                              className={`React ${formik.touched.AddressProof &&
                                formik.errors.AddressProof
                                ? "is-invalid"
                                : ""
                                }`}
                              classNamePrefix="select"
                              name="AddressProof"
                              options={addressProof}
                              onChange={(selectedOption) =>
                                formik.setFieldValue(
                                  "AddressProof",
                                  selectedOption
                                )
                              }
                              value={formik.values.AddressProof}
                              styles={generateCustomStyles(
                                "AddressProof",
                                formik
                              )}
                            />
                            {formik.touched.AddressProof &&
                              formik.errors.AddressProof && (
                                <FormFeedback>
                                  {formik.errors.AddressProof.value}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>

                        <Col sm="4">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              Document Number
                              <span className="mandatory">*</span>
                            </Label>
                            <Input
                              invalid={
                                formik.touched.AddressProofNumber &&
                                !!formik.errors.AddressProofNumber
                              }
                              disabled={!isEditable}
                              type="text"
                              name="AddressProofNumber"
                              id="nameVertical"
                              placeholder="ID Number"
                              onChange={formik.handleChange}
                              // value={formik.values.AddressProofNumber?.toUpperCase()}
                              value={
                                isEditable
                                  ? formik.values.AddressProofNumber?.toUpperCase()
                                  : maskDocumentNumber(
                                    formik.values.AddressProofNumber
                                  )
                              }
                            />
                            {formik.touched.AddressProofNumber &&
                              formik.errors.AddressProofNumber && (
                                <FormFeedback>
                                  {formik.errors.AddressProofNumber}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>

                        <Col sm="4">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              Document Proof{" "}
                              {formik?.values?.AddressProofFile ? (
                                <a
                                  href={
                                    userData.fld_addressproofurl === ""
                                      ? URL.createObjectURL(
                                        formik.values?.AddressProofFile
                                      )
                                      : process.env.REACT_APP_FILE_PATH_URL +
                                      userData.fld_addressproofurl
                                  }
                                  target="__blank"
                                  className="ml-2 text-primary"
                                >
                                  ( View )
                                </a>
                              ) : (
                                "(upload .pdf file)"
                              )}
                              <span className="mandatory cursor-pointer">
                                *
                              </span>
                            </Label>

                            <CustomInput
                              type="file"
                              name="AddressProofFile"
                              accept="application/pdf"
                              id="nameVertical"
                              invalid={
                                formik.touched.AddressProofFile &&
                                !!formik.errors.AddressProofFile
                              }
                              disabled={!isEditable}
                              onChange={(e) => {
                                e.preventDefault();
                                const file = e.target.files[0];
                                formik.setFieldValue("AddressProofFile", file);
                                if (file && file.size > 5000000) {
                                  Notiflix.Notify.failure(
                                    "File too large, upload file less than 5 Mb."
                                  );
                                }
                              }}
                            />
                            {formik.touched.AddressProofFile &&
                              formik.errors.AddressProofFile && (
                                <FormFeedback>
                                  {formik.errors.AddressProofFile}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                  </CardBody>
                </Card>

                {(tempUser?.fld_usertype == "Staff" ||
                  tempUser?.fld_isadmin == 1) && (
                    <Card
                      className="mt-3 border-0"
                      id="jobCard"
                      style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
                    >
                      <h6 className="my-3 ml-4 headingStyle">Bank Details</h6>
                      <CardBody>
                        <div>
                          <Row>
                            <Col sm="4">
                              <FormGroup>
                                <Label htmlFor="nameVertical">Bank Name</Label>
                                <Input
                                  disabled={true}
                                  type="text"
                                  name="IdProofNumber"
                                  id="nameVertical"
                                  placeholder="Bank Name"
                                  onChange={formik.handleChange}
                                  value={formik.values.bankName}
                                />
                              </FormGroup>
                            </Col>
                            <Col sm="4">
                              <FormGroup>
                                <Label htmlFor="nameVertical">Bank State</Label>
                                <Input
                                  disabled={true}
                                  type="text"
                                  name="IdProofNumber"
                                  id="nameVertical"
                                  placeholder="Bank State"
                                  onChange={formik.handleChange}
                                  value={formik.values.bankState}
                                />
                              </FormGroup>
                            </Col>
                            <Col sm="4">
                              <FormGroup>
                                <Label htmlFor="nameVertical">Bank City</Label>
                                <Input
                                  disabled={true}
                                  type="text"
                                  name="IdProofNumber"
                                  id="nameVertical"
                                  placeholder="Bank City"
                                  onChange={formik.handleChange}
                                  value={formik.values.bankCity}
                                />
                              </FormGroup>
                            </Col>
                            <Col sm="4">
                              <FormGroup>
                                <Label htmlFor="nameVertical">
                                  Account Number
                                </Label>
                                <Input
                                  disabled={true}
                                  type="text"
                                  name="IdProofNumber"
                                  id="nameVertical"
                                  placeholder="Account Number"
                                  onChange={formik.handleChange}
                                  value={formik.values.bankAccountNo}
                                />
                              </FormGroup>
                            </Col>

                            <Col sm="4">
                              <FormGroup>
                                <Label htmlFor="nameVertical">
                                  Account Holder Name
                                </Label>
                                <Input
                                  disabled={true}
                                  type="text"
                                  name="IdProofNumber"
                                  id="nameVertical"
                                  placeholder="Account Holder Name"
                                  onChange={formik.handleChange}
                                  value={formik.values.bankHolderName}
                                />
                              </FormGroup>
                            </Col>

                            <Col sm="4">
                              <FormGroup>
                                <Label htmlFor="nameVertical">IFSC Code</Label>
                                <Input
                                  disabled={true}
                                  type="text"
                                  name="IdProofNumber"
                                  id="nameVertical"
                                  placeholder="IFSC Code"
                                  onChange={formik.handleChange}
                                  value={formik.values.bankIFSC}
                                />
                              </FormGroup>
                            </Col>
                            <Col sm="4">
                              <FormGroup>
                                <Label htmlFor="nameVertical">UPI Id</Label>
                                <Input
                                  disabled={true}
                                  type="text"
                                  name="IdProofNumber"
                                  id="nameVertical"
                                  placeholder="Upi id"
                                  onChange={formik.handleChange}
                                  value={formik.values.UpiNo}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </div>
                      </CardBody>
                    </Card>
                  )}
                <Card
                  className="mt-3 border-0"
                  style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
                >
                  <p className="mt-3 ml-4 headingStyle">Resume</p>

                  <CardBody>
                    <Row>
                      <Col sm="4">
                        <FormGroup>
                          <Label htmlFor="nameVertical">
                            Upload Resume
                            {formik?.values?.resumeFile ? (
                              <a
                                // href={formik?.values?.resumeFile}
                                href={
                                  userData.fld_resumeurl === ""
                                    ? URL.createObjectURL(
                                      formik.values?.resumeFile
                                    )
                                    : process.env.REACT_APP_FILE_PATH_URL +
                                    userData.fld_resumeurl
                                }
                                target="__blank"
                                className="ml-2 text-primary"
                              >
                                ( View )
                              </a>
                            ) : (
                              "(.pdf file)"
                            )}
                          </Label>

                          <CustomInput
                            type="file"
                            name="resumeFile"
                            accept="application/pdf"
                            id="nameVertical"
                            disabled={!isEditable}
                            invalid={
                              formik.touched.resumeFile &&
                              !!formik.errors.resumeFile
                            }
                            onChange={(e) => {
                              e.preventDefault();
                              const file = e.target.files[0];
                              formik.setFieldValue("resumeFile", file);
                              if (file && file.size > 5000000) {
                                Notiflix.Notify.failure(
                                  "File too large, upload file less than 5 Mb."
                                );
                              }
                            }}
                          />
                          {formik.touched.resumeFile &&
                            formik.errors.resumeFile && (
                              <div className="error text-danger pl-2">
                                {formik.errors.resumeFile}
                              </div>
                            )}
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Card
                  className="mt-3 border-0"
                  style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
                >
                  <CardBody>
                    <Row>
                      <Col sm="12" className="my-2">
                        <Label>
                          <span style={{ fontWeight: "bolder" }}>Note : </span>
                          All fields marked with ({" "}
                          <span className="mandatory">*</span> ) are mandatory.
                        </Label>
                      </Col>
                    </Row>
                    {isEditable && (
                      <div className="text-right">
                        <button
                          // className="submit send-btn"
                          className="btns"
                          onClick={() => submitHandler("Updated")}
                        >
                          Save
                        </button>
                      </div>
                    )}
                  </CardBody>
                </Card>
              </FormGroup>
            </div>
          </div>
        </div>
        {recruiterRemarkModal === true && (
          <CommonModal
            isOpen={recruiterRemarkModal}
            toggle={() => setRecruiterRemarkModal(false)}
            heading={"Onboarding Status"}
            contentBody={
              <div style={{ marginTop: "0px" }}>
                <div>
                  <div
                    className="dropdown actions-dropdown my-2"
                  // style={{ zIndex: 20 }}
                  >
                    <Label for="nameVertical">
                      Candidate Status
                      <span className="mandatory">*</span>
                    </Label>

                    <Select
                      className=""
                      classNamePrefix="select"
                      placeholder="Select"
                      name="recruiterStatus"
                      options={userStatus}
                      onChange={(selectedOption) => {
                        setSelectedRecruiterStatus(selectedOption);
                      }}
                      value={recruiterStatus}
                    />
                    {validationErrors?.recruiterStatus && (
                      <small className="text-danger">
                        {validationErrors.recruiterStatus}
                      </small>
                    )}
                  </div>
                  <div>
                    <Label for="nameVertical">
                      Recruiter Remarks
                      <span className="mandatory">*</span>
                    </Label>
                    <Input
                      type="textarea"
                      className="w-100 mt-1 p-2"
                      placeholder="Message ..."
                      value={recruiterRemark}
                      // style={{paddingLeft: "10px" }}
                      onChange={(e) => {
                        setRecruiterRemark(e.target.value);
                      }}
                    />
                    {validationErrors?.recruiterRemark && (
                      <small className="text-danger">
                        {validationErrors.recruiterRemark}
                      </small>
                    )}
                  </div>
                </div>
                <div>
                  <h6 className="mt-2 text-dark">Candidate Rating Summary</h6>
                  {/* Dynamically render RatingSummary components */}
                  {ratingFields.map((field) => (
                    <>
                      <RatingSummary
                        key={field.id}
                        heading={field.heading}
                        id={field.id}
                        name={field.name}
                        ratingsState={ratingsState}
                        setRatingsState={setRatingsState}
                      />
                      {field.id !== "availability" && <hr className="my-1" />}
                    </>
                  ))}
                </div>
              </div>
            }
            onConfirm={handleOnBoardStatus}
            confirmText={"submit"}
            // acceptText={<Check size={15} />}
            // rejectText={<X size={15} />}
            cancelText={"Cancel"}
            onCancel={() => setRecruiterRemarkModal(false)}
          />
        )}
        {verifyModal === true && (
          <CommonModal
            isOpen={verifyModal}
            toggle={() => setVerifyModal(false)}
            heading={"Employee Verification"}
            contentBody={
              <div style={{ marginTop: "0px" }}>
                <div>
                  <div
                    className="dropdown actions-dropdown my-2"
                    style={{ zIndex: 20 }}
                  >
                    <Label for="nameVertical">
                      Employee Type
                      <span className="mandatory">*</span>
                    </Label>

                    <Select
                      className=""
                      classNamePrefix="select"
                      placeholder="Select"
                      name="recruiterStatus"
                      options={[
                        { label: "Betel Jobs Auditor", value: 1 },
                        { label: "TRPW Employee/Auditor", value: 2 },
                      ]}
                      onChange={(selectedOption) => {
                        formik.setFieldValue("verifyemp", selectedOption);
                      }}
                      value={formik.values.verifyemp}
                    />
                  </div>
                </div>
              </div>
            }
            onConfirm={VerifyEmployeeHandler}
            confirmText={"submit"}
            // acceptText={<Check size={15} />}
            // rejectText={<X size={15} />}
            cancelText={"Cancel"}
            onCancel={() => setVerifyModal(false)}
          />
        )}
      </section>
    </div>
  );
};

export default ViewAuditor;
